import { render, staticRenderFns } from "./my_academic_thesis_usach_tab.vue?vue&type=template&id=e7cf984c"
import script from "./my_academic_thesis_usach_tab.vue?vue&type=script&lang=js"
export * from "./my_academic_thesis_usach_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports